import React from "react";
import "./choix-chips.scss";

// ============================================================
// ChoixChips — choix exclusif rendu en puces (des boutons radio habillés) :
// une année, un secteur, un rôle. Le groupe est un <fieldset> avec sa
// légende ; la puce cochée passe en espoar-blue, le focus clavier reste
// visible sur la puce (l'input est masqué visuellement, pas retiré).
// options : [{ [dataIndex], [dataLabel], icon?, disabled? }]
// onChange(valeur, option) est appelé au changement.
// variant : label (défaut) | eyebrow | inline | segmente (options jointes en
// un contrôle de 36 px, aligné sur les champs — filtres « Tous / Oui / Non »).
// ============================================================
const ChoixChips = ({
  name,
  legend,
  legendSrOnly = false,
  options = [],
  value,
  onChange,
  dataIndex = "id",
  dataLabel = "name",
  size = "md",
  variant = "label",
  className = "",
  error = null,
  disabled = false,
}) => (
  <fieldset
    className={`choix-chips choix-chips--${size} choix-chips--${variant} ${className}`.trim()}
    disabled={disabled || undefined}
  >
    <legend className={legendSrOnly ? "sr-only" : "choix-chips__legende"}>{legend}</legend>
    <div className="choix-chips__liste">
      {options.map((option) => {
        const valeur = option[dataIndex];
        const id = `${name}-${String(valeur).replace(/[^a-zA-Z0-9_-]/g, "-")}`;
        const coche = String(value) === String(valeur);
        return (
          <label
            key={id}
            htmlFor={id}
            className={`choix-chip${coche ? " is-checked" : ""}${option.disabled ? " is-disabled" : ""}`}
          >
            <input
              type="radio"
              id={id}
              name={name}
              value={valeur}
              checked={coche}
              disabled={option.disabled || undefined}
              onChange={() => onChange(valeur, option)}
              className="sr-only"
            />
            {option.icon && <i className={`fa fa-${option.icon}`} aria-hidden="true" />}
            {option[dataLabel]}
          </label>
        );
      })}
    </div>
    {error && (
      <small role="alert" className="form-text text-danger">
        {error}
      </small>
    )}
  </fieldset>
);

export default ChoixChips;
